import * as React from "react";
import { Heading } from "../../typography/heading/heading.mjs";
import { ScrollFade } from "../../scroll-fade/scroll-fade.mjs";
import { Separator } from "../../separator/separator.mjs";
import { CommentsItem } from "../comments-item/comments-item.mjs";
const Comments = (props) => {
  const { color, className, title, items, replyForm, fullWidth, commentsHeight = "unset", headingLevel = 4 } = props;
  const [chatContainer, setChatContainer] = React.useState(null);
  React.useEffect(() => {
    if (chatContainer) {
      chatContainer.scrollTop = chatContainer.scrollHeight;
    }
  }, [chatContainer]);
  const BEM = () => {
    const classArray = ["comments"];
    if (color) {
      classArray.push("comments--" + color);
    }
    if (fullWidth) {
      classArray.push("comments--full-width");
    }
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  return /* @__PURE__ */ React.createElement("div", { className: BEM() }, title && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(Heading, { level: headingLevel, className: "h4" }, title), /* @__PURE__ */ React.createElement(Separator, { spacing: "xsmall", color: "invisible" })), /* @__PURE__ */ React.createElement("div", { className: "comments__inner", style: { maxHeight: commentsHeight, height: commentsHeight } }, /* @__PURE__ */ React.createElement(ScrollFade, { elementRef: (el) => setChatContainer(el) }, items.map((comment) => {
    return /* @__PURE__ */ React.createElement(CommentsItem, { ...comment, key: comment.id });
  }))), replyForm && /* @__PURE__ */ React.createElement("div", { className: "comments__reply-form" }, replyForm));
};
export {
  Comments
};
